enum AvailableLocales {
  UK = 'uk',
  EN = 'en',
}

export { AvailableLocales };
